import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Header } from '../../components/shared/header/header';
import { LeadsTable, LeadColumn, LeadRow, FilterConfig, ServerSidePagination, ServerSidePaginationInterface } from '../../components/shared/leads-table/leads-table';
import { LeadsFilaService } from '../../services/leads-fila.service';
import { LeadsFilaRequest, LeadsFilaItem, LeadsFilaResponse } from '../../interfaces/leads-fila.interface';
import { catchError } from 'rxjs/operators';
import { Observable, of, Subscription } from 'rxjs';
import { SelectedDnService } from '../../services/selected-dn.service';
import { LeadsDataService } from '../../services/data/Leads.data.service';
import { ServerSidePaginationModel } from '../../components/shared/leads-table/models/serverSidePagination.model';
import { HttpErrorResponse } from '@angular/common/http';
import { availableOriginsType } from '../../components/shared/filter-fields/models/filter-field.model';
import { DateUtil } from '../../utils/date-utils';
import { DashboardStoreService } from '../../services/store/dashboard.store.service';

@Component({
  selector: 'app-sign-drive-component',
  standalone: true,
  imports: [CommonModule, RouterModule, Header, LeadsTable],
  templateUrl: './sign-drive.component.html',
  styleUrls: ['./sign-drive.component.scss']
})
export class SignDriveComponent implements OnInit, OnDestroy, AfterViewInit {
  private dnSubscription?: Subscription;
  private hasLoadedInitialData = false;
  private hasReceivedInitialDates = false;
  private isLoading = false;
  private initialLoadDone = false;
  private readonly tipoCampanha = 5;
  private currentSearchText: string | undefined = undefined;
  private currentFilters: string[] = [];
  private currentDateRange: { start: string, end: string } = { start: '', end: '' };
  private currentSortField: string = 'disponivelDesde';
  private currentSortOrder?: 'ASC' | 'DESC' = 'DESC';

  @ViewChild(LeadsTable) leadsTable?: LeadsTable;

  tableColumns: LeadColumn[] = [
    { key: 'nome', label: 'Nome', type: 'text' },
    { key: 'origem', label: 'Origem', type: 'text' },
    { key: 'disponivelDesde', label: 'Data de Simulação', type: 'text' },
    { key: 'ultimoContato', label: 'Último Contato', type: 'text' },
    { key: 'retornarEm', label: 'Retornar Em', type: 'text' },
    { key: 'status', label: 'Status do Lead', type: 'status' }
  ];

  filterConfig: FilterConfig = {
    searchFields: ['nome'],
    alphabeticalField: 'NM_NOME',
    filterFields: {
      origin: 'origem'
    },
    dateField: 'disponivelDesde'
  };
  leadsFilaRequest!: LeadsFilaRequest;
  tableData: LeadRow[] = [];
  loading: boolean = false;
  loadingMessage: string = 'Carregando dados...';
  errorMessage: string = '';
  emptyMessage: string = 'Nenhum lead encontrado para o tipo de campanha informada.';
  serverSidePagination = new ServerSidePaginationModel();
  availableFilterOrigins: availableOriginsType[] = ['S&D-PF', 'S&D-PJ', 'S&D-CONCESSIONARIOS', 'S&D-COBRANDED'];

  constructor(
    private readonly router: Router,
    private leadsDataService: LeadsDataService,
    private leadsFilaService: LeadsFilaService,
    private selectedDnService: SelectedDnService,
    private readonly dashboardStoreService: DashboardStoreService,
  ) { }

  ngOnInit(): void {
    this.currentDateRange = DateUtil.getDateRange(3);

    this.dnSubscription = this.selectedDnService.selectedDn$.subscribe(dn => {
      if (dn && this.hasReceivedInitialDates && this.initialLoadDone) {
        this.loadData();
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (!this.hasLoadedInitialData && !this.hasReceivedInitialDates && !this.isLoading) {
        this.hasReceivedInitialDates = true;
        this.loadData();
      }
    }, 200);
  }

  ngOnDestroy(): void {
    if (this.dnSubscription) {
      this.dnSubscription.unsubscribe();
    }
  }

  private loadData(): void {
    if (this.isLoading)
      return;

    //! (sem padrõnização)
    //! ISSO NÃO TA LEGAL NÃO, ZERAR PADRÕES NO MEIO DO FLUXO DE DADOS,
    this.isLoading = true;
    this.loading = true;
    this.loadingMessage = 'Carregando simulações...';
    this.errorMessage = '';
    this.emptyMessage = 'Nenhum lead encontrado para o tipo de campanha informada.';

    this.montLeadsFilaRequest();
    this.leadsFilaService
      .getLeadsFila(this.leadsFilaRequest)
      .pipe(
        //! ESSE catchError DEFINITIVAMENTE NÃO DEVERIA ESTAR AQUI - TALVEZ UM SERVICE, MAIS PROVAVELMENTE UM MIDLEWARE
        //! RESOLVER
        catchError((error: HttpErrorResponse) => this.resolveError(error))
      ).subscribe((response: LeadsFilaResponse | null) => this.resolveRespoonse(response));
  }

  private resolveError(error: HttpErrorResponse): Observable<null> {
    this.isLoading = false;
    this.loading = false;

    if (error.status === 401) {
      this.errorMessage = 'Não autorizado. Redirecionando...';
      setTimeout(() => {
        this.router.navigate(['/login']);
      }, 2000);
    } else if (error.status === 204) {
      this.emptyMessage = 'Nenhum lead encontrado para o tipo de campanha informada.';
      this.tableData = [];
    } else {
      this.errorMessage = 'Erro ao carregar dados. Tente novamente.';
    }

    return of(null);
  }

  private montLeadsFilaRequest(): void {
    this.leadsFilaRequest = this.leadsDataService.montLeadsFilaRequest(
      this.tipoCampanha,
      this.selectedDnService.getSelectedDnAsNumber(),
      this.currentFilters,
      this.currentSearchText,
      this.currentDateRange,
      this.serverSidePagination,
      this.currentSortField,
      this.currentSortOrder
    )
  }

  private resolveRespoonse(response: LeadsFilaResponse | null) {
    this.isLoading = false;
    this.loading = false;

    //! Por que (response.data.length > 0) neste  IF é necessário ? response?.data.length não seria suficiente?
    if (response && response.data && response.data.length > 0) {
      this.tableData = this.leadsDataService.mapLeadResponse(response.data);
      this.serverSidePagination.set(
        response.pagination.totalRecords,
        response.pagination.page,
        response.pagination.pageSize,
        response.pagination.from,
        response.pagination.to
      );

      this.hasLoadedInitialData = true;
      this.initialLoadDone = true;
    } else {
      this.emptyMessage = response?.message || 'Nenhum lead encontrado para o tipo de campanha informada.';
      this.tableData = [];
      this.hasLoadedInitialData = true;
      this.initialLoadDone = true;
    }
  }

  onDateRangeChange(dateRange: { start: string, end: string }): void {
    if (this.currentDateRange.start === dateRange.start &&
      this.currentDateRange.end === dateRange.end) {
      return;
    }

    this.hasReceivedInitialDates = true;

    if (dateRange.start && dateRange.end) {
      this.currentDateRange = dateRange;
    } else {
      this.currentDateRange = dateRange;
    }

    this.loadData();
  }

  onSortChange(sort: { field: string, order: 'ASC' | 'DESC' }): void {
    this.currentSortField = sort.field;
    this.currentSortOrder = sort.order;
    this.serverSidePagination.set();
    this.serverSidePagination.pageSize = this.serverSidePagination?.pageSize || 20;
    this.loadData();
  }

  onSearchChange(searchText: string): void {
    this.currentSearchText = searchText;
    this.serverSidePagination.set();
    this.loadData();
  }

  onFilterChange(filters: string[]): void {
    this.currentFilters = filters;
    this.serverSidePagination.set();
    this.loadData();
  }

  onClearAllFilters(): void {
    this.currentSearchText = '';
    this.currentFilters = [];
    this.currentDateRange = { start: '', end: '' };
    this.currentSortField = '';
    this.currentSortOrder = 'DESC';
    this.hasReceivedInitialDates = true;
    this.loadData();
  }

  onPageSizeChange(newPageSize: number): void {
    this.serverSidePagination.pageSize = newPageSize;
    this.loadData();
  }

  onPageChange(newPage: number): void {
    if (this.serverSidePagination) {
      this.serverSidePagination.page = newPage;
      this.loadData();
    }
  }

  onViewLead(lead: LeadRow): void {
    if (lead.idLead) {
      this.router.navigate([`/leads/${lead.idLead}/detalhes`]);
    }
  }
}
